import _defineProperty from "/tmp/caradvise-production/24/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/tmp/caradvise-production/24/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/caradvise-production/24/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { startSpan, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, getCurrentHub } from '@sentry/core';
import { addNonEnumerableProperty, logger } from '@sentry/utils';
import { DEBUG_BUILD } from '../../common/debug-build.js';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';

function isValidPrismaClient(possibleClient) {
  return !!possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */


var Prisma = /*#__PURE__*/function () {
  _createClass(Prisma, null, [{
    key: "__initStatic",

    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'Prisma';
    }
    /**
     * @inheritDoc
     */

    /**
     * @inheritDoc
     */

  }]);

  function Prisma() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Prisma);

    this.name = Prisma.id; // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
    // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
    // in setupOnce we can only ever instrument one client.
    // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
    // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.

    if (isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      addNonEnumerableProperty(options.client, '_sentryInstrumented', true);
      var clientData = {};

      try {
        var engineConfig = options.client._engineConfig;

        if (engineConfig) {
          var activeProvider = engineConfig.activeProvider,
              clientVersion = engineConfig.clientVersion;

          if (activeProvider) {
            clientData['db.system'] = activeProvider;
          }

          if (clientVersion) {
            clientData['db.prisma.version'] = clientVersion;
          }
        }
      } catch (e) {// ignore
      }

      options.client.$use(function (params, next) {
        // eslint-disable-next-line deprecation/deprecation
        if (shouldDisableAutoInstrumentation(getCurrentHub)) {
          return next(params);
        }

        var action = params.action;
        var model = params.model;
        return startSpan({
          name: model ? "".concat(model, " ").concat(action) : action,
          onlyIfParent: true,
          op: 'db.prisma',
          attributes: _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.db.prisma'),
          data: _objectSpread(_objectSpread({}, clientData), {}, {
            'db.operation': action
          })
        }, function () {
          return next(params);
        });
      });
    } else {
      DEBUG_BUILD && logger.warn('Unsupported Prisma client provided to PrismaIntegration. Provided client:', options.client);
    }
  }
  /**
   * @inheritDoc
   */


  _createClass(Prisma, [{
    key: "setupOnce",
    value: function setupOnce() {// Noop - here for backwards compatibility
    }
  }]);

  return Prisma;
}();

Prisma.__initStatic();

export { Prisma };